import { createContext, useContext, useState } from 'react'

const TransferContext = createContext({
    page: 0,
    setPage: (p) => { },
    pageNumber: 0,
    setPageNumber: (p) => { },
    source: "",
    setSource: (s) => { },
    destination: "",
    setDestination: (s) => { },
    amount: "",
    setAmount: (s) => { },
    code: "",
    setCode: (c) => { },
})

export const exampleAccs = [
    "ABC Trading - 123456",
    "XYZ Trading - 098765",
    // "Cash Account"
]

export const exampleDests = [
    "Trading Account - 12345678",
    "Trading Account - 09876543"
]

const TransferContextProvider = ({ children }) => {
    const [page, setPage] = useState(0)
    const [pageNumber, setPageNumber] = useState(0)
    const [source, setSource] = useState("")
    const [amount, setAmount] = useState("")
    const [code, setCode] = useState("")
    const [destination, setDestination] = useState("")

    return (
        <TransferContext.Provider value={{
            page,
            setPage,
            amount,
            setAmount,
            pageNumber,
            setPageNumber,
            source,
            setSource,
            destination,
            setDestination,
            code,
            setCode
        }}>
            {children}
        </TransferContext.Provider>
    )
}

export const TransferContextCustomer = ({ children }) => {
    return (
        <TransferContext.Consumer>
            {children}
        </TransferContext.Consumer>
    )
}

export const useTransferContext = () => {
    const context = useContext(TransferContext)
    if (context === undefined) {
        throw new Error('useTransferContext must be used within a TransferContextProvider')
    }
    return context
}

export default TransferContextProvider